// src/components/products/ProductForm/TransferDetailsSections/TransferItinerarySection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TransferItinerarySection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Itinerary - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="خط سير الرحلة (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="itinerary_ar"
                        value={formData.itinerary?.ar || ''}
                        onChange={(e) => handleMultiLangChange('itinerary', 'ar', e.target.value)}
                        rows={4}
                        error={!!errors.itinerary_ar}
                        helperText={errors.itinerary_ar}
                    />
                </Grid>
            )}

            {/* Itinerary - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Itinerary (English)"
                        type="editor"
                        textareaRows={200}
                        name="itinerary_en"
                        value={formData.itinerary?.en || ''}
                        onChange={(e) => handleMultiLangChange('itinerary', 'en', e.target.value)}
                        rows={4}
                        error={!!errors.itinerary_en}
                        helperText={errors.itinerary_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default TransferItinerarySection;
